<div [formGroup]="simForm" fxLayout="row wrap" fxLayoutAlign="space-between">


  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field fxFlex="45">
    <mat-label>Expiration Date </mat-label>

    <input formControlName="expirationDate" (focusin)="expirationDatePicker.open()" readonly
      [matDatepicker]="expirationDatePicker" [min]="dateNow" matInput name="expirationDate">
    <mat-datepicker-toggle [for]="expirationDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="simForm.controls.expirationDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #expirationDatePicker></mat-datepicker>

    <mat-error
      *ngIf="simForm.controls.expirationDate?.errors?.pattern && !simForm.controls.expirationDate?.errors?.required">
      Please enter a valid expiration date
    </mat-error>
    <mat-error *ngIf="simForm.controls.expirationDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Identifier </mat-label>
    <input formControlName="identifier" matInput name="identifier" type="text">
    <mat-error
      *ngIf="simForm.controls.identifier?.errors?.identifier && !simForm.controls.identifier?.errors?.required">
      Please enter a valid identifier
    </mat-error>
    <mat-error *ngIf="simForm.controls.identifier?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Data Usage </mat-label>
    <input formControlName="dataUsage" matInput min="0" name="dataUsage" type="number">
    <mat-error *ngIf="simForm.controls.dataUsage?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Max Data Usable </mat-label>
    <input formControlName="maxDataUsable" matInput min="1" name="maxDataUsable" type="number">
    <mat-error *ngIf="simForm.controls.maxDataUsable?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Sim Operator </mat-label>
    <input formControlName="simOperator" matInput name="simOperator" type="text">
    <mat-error *ngIf="simForm.controls.simOperator?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Monthly Fee </mat-label>
    <input formControlName="monthlyFee" matInput min="0" name="monthlyFee" type="number">
    <mat-error *ngIf="simForm.controls.monthlyFee?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="!creatingFromBox && !isEditing">
    <mat-form-field fxFlex="45">
      <mat-label>Box</mat-label>
      <mat-select [(value)]="selectedBox" [disabled]="isEditing" formControlName="box" name="box">

        <mat-option *ngIf="!loadingBoxes && boxes.length === 0">
          No boxes available.
        </mat-option>
        <mat-option *ngFor="let box of boxes" [value]="box">
          {{box.identifier}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingBoxes" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>

      <mat-hint *ngIf="!loadingBoxes && boxes.length === 0" class="color-warn">
        No boxes available.
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <button (click)="sim = _sim; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveSim()" [disabled]="simForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>